module.exports = __webpack_public_path__ + "img/编辑 (1).45e68184.png";